import axiosClient from "../services/axiosClient";

export const getFileType = (filename) => {
  const extension = filename.split(".").pop().toLowerCase();
  return extension;
};

export const fetchFile = async (path, fileType = "pdf") => {
  try {
    const filesExtensionsMap = {
      pdf: "application/pdf",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    };
    const response = await axiosClient.get(path, {
      responseType: "blob",
    });

    if (!response.data) {
      throw new Error("No data received");
    }

    const blob = new Blob([response.data], {
      type: filesExtensionsMap[fileType] || "application/pdf",
    });

    return blob;
  } catch (error) {
    console.error("Error fetching file:", error);
    return null;
  }
};

export function buildInvoiceDocUrl(doc) {
  return `${process.env.REACT_APP_URL}/multiContainerInvoiceWithoutC/getInvoiceFile/${doc?.id}`;
}

export function sortByCustomOrder(array, orderKeys, propertyName = "type") {
  return [...array].sort((a, b) => {
    const indexA = orderKeys.indexOf(a[propertyName]);
    const indexB = orderKeys.indexOf(b[propertyName]);

    // Handle items not in orderKeys (put them at the end)
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });
}

// Usage example:
const orderedKeys = [
  "BaghdadTransactionRequest",
  "BaghdadEntryRequest",
  "BaghdadPaymentDetails",
  "BaghdadPromise",
  "BaghdadConfirmation",
];
